import Template from "@/widgets/index.js";
import styles from "./styles.module.css";

const ContenedorTitulo = (props) => {
  const {
    text, 
    links, 
    color = "#3a9fdc"
  } = props;

  return (
    <div className={styles["content"]}>
      <Template.Titulo
        text={text}
        links={links}
        color={color}
      />
    </div>
  );
}

export default ContenedorTitulo;